/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Parameters_And_CommandsInputs */



/**
* | output |
* | --- |
* | "Parameters and commands" |
*
* @param {Parameters_And_CommandsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const parameters_and_commands = /** @type {((inputs?: Parameters_And_CommandsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Parameters_And_CommandsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Parameters and commands")
	return /** @type {LocalizedString} */ ("Paramètres et commandes")
});